import { render, staticRenderFns } from "./NewPluginTableItemsSkeleton.vue?vue&type=template&id=36394ebf&scoped=true"
import script from "./NewPluginTableItemsSkeleton.vue?vue&type=script&lang=js"
export * from "./NewPluginTableItemsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./NewPluginTableItemsSkeleton.vue?vue&type=style&index=0&id=36394ebf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36394ebf",
  null
  
)

export default component.exports